import styled from 'styled-components';

import { red, yellow, black, white } from 'utils/style/colors';
import { zindex } from 'utils/style/zindex';
import { fadeInToast, fadeOutToast } from 'utils/style/animations';

import Icon from 'components/Icon';
import { NotificationType } from 'store/notifications/NotificationsSlice';

export const TOAST_TRANSITION_CLASS_NAME = 'toast';

const successfulGreen: string = '#4bae4f';
const blueInformation: string = '#03a9f4';

interface IToastStyleProps {
  type: NotificationType;
}

export const ToastCloseIcon = styled(Icon)`
  color: inherit;
  cursor: pointer;
  margin-right: 0.75rem;
  align-self: center;
`;

export const ToastWrapper = styled('div')<IToastStyleProps>`
  display: flex;
  pointer-events: auto;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  border-radius: 10px;
  min-width: 18rem;
  margin-top: 0.5rem;
  z-index: ${zindex.toast};
  bottom: 0;
  position: relative;
  &.${TOAST_TRANSITION_CLASS_NAME}-enter {
    animation: ${fadeInToast} 0.3s ease both;
  }
  &.${TOAST_TRANSITION_CLASS_NAME}-exit {
    animation: ${fadeOutToast} 0.3s ease both;
  }
  ${(props) => {
    switch (props.type) {
      case 'info':
        return `background-color: ${blueInformation};`;
      case 'successful':
        return `background-color: ${successfulGreen};`;
      case 'warning':
        return `background-color: ${yellow};`;
      case 'error':
        return `background-color: ${red};`;
      default:
        return 'background-color: rgb(50, 50, 50);';
    }
  }}
  color: ${(props) => (props.type === 'warning' ? black : white)};
`;

export const ToastMessage = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 0.87rem;
  font-weight: 400;
  line-height: 1.5;
  user-select: none;
`;
